import React from "react";
import ProductCard from "./ProductCard";
import {Card, CardBody} from "reactstrap";
import products from '../products.json';
import {Element} from "react-scroll";
import {useTranslation} from "react-i18next";

function ProductsList() {
    const {t} = useTranslation();
    return (
        <Element name="products">
            <div className="container mt-5">
                <Card className="shadow-lg border-0 rounded-5 p-4">
                    <CardBody>
                        <h2 className="text-center text-success mb-5">{t("ourProducts")}</h2>
                        <div className="row justify-content-center">
                            {products.map((product, index) => (
                                <div key={index} className="col-12 col-md-7 col-lg-4 d-flex mb-4">
                                    <div className="card w-100 shadow-sm border-0 rounded-4">
                                        <ProductCard
                                            title={product.title}
                                            description={product.description}
                                            images={product.images}
                                            advantages={product.advantages}
                                            advantagesLabel={product.advantagesLabel}
                                            dimensions={product.dimensions}
                                            dimensionLabel={product.dimensionLabel}
                                            additionally={product.additionally}
                                            id={`carousel-${index}`}
                                            secondDimensionLabel={product.secondDimensionLabel}
                                            secondDimensions={product.secondDimensions}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Element>
    )
        ;
}

export default ProductsList;
